import React, { useCallback, useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import styles from "./IntroScreen.module.scss";
import { useDispatch } from "react-redux";
import { updateUserLogin } from "../../redux/slices/userSlice";

const imageCache = {}; // Persist across renders

export const IntroDisplayTime = +(process.env.REACT_APP_INTRO_SCREEN_WAIT_TIME || 4000) + 500;

export const IntroScreen = ({ showIntro, updateCallbackRef, imgUrl = "/images/intro-scrren.jpg" }) => {
  const [isIntroImgLoaded, setIsIntroImgLoaded] = useState(null);
  const [imgSrc, setImgSrc] = useState(null);

  const dispatch = useDispatch();

  const loadImage = useCallback(async () => {
    if (imageCache[imgUrl]) {
      return imageCache[imgUrl];
    }

    const imgPromise = new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = async () => {
        await img.decode();
        imageCache[imgUrl] = img.src;
        resolve(img.src);
      };
      img.onerror = reject;
      img.src = imgUrl;
    });

    return await imgPromise;
  }, [imgUrl]);

  useEffect(() => {
    loadImage()
      .then((loadedSrc) => {
        setImgSrc(loadedSrc);
        setIsIntroImgLoaded(true);
      })
      .catch((error) => {
        setIsIntroImgLoaded(false);
        console.error("Image load error:", error);
      });
  }, [loadImage]);

  useEffect(() => {
    if (typeof updateCallbackRef.current === "function") {
      updateCallbackRef.current({ isIntroImgLoaded, imgSrc });
    }
  }, [isIntroImgLoaded, updateCallbackRef, imgSrc]);

  return (
    <div
      className={styles.introWrapper}
      style={{
        opacity: showIntro ? 1 : "",
        zIndex: showIntro ? 99 : "",
      }}
    >
      <div className={styles.imageContainer}>
        {imgSrc && <img alt="Intro" src={imgSrc} />}

        <span className={styles.close} onClick={() => dispatch(updateUserLogin(true))}>
          <IoClose size={30} color="#f42121" />
        </span>
      </div>
    </div>
  );
};
